import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyDlP_ES9Wq1PDw4GorpPyCmZeexJTxNqHw",
  authDomain: "easyfin-floren.firebaseapp.com",
  projectId: "easyfin-floren",
  storageBucket: "easyfin-floren.firebasestorage.app",
  messagingSenderId: "934671874084",
  appId: "1:934671874084:web:dff9681c130fb5ce2500b1",
  measurementId: "G-P8CK83HGDD"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };